import React from 'react';

function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="text-sm text-gray-500">
            © 2025 Chad Stachowicz
          </div>
          <div>
            <img
              src="/master_green.png"
              alt="UNC Charlotte Logo"
              className="h-12 w-auto"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 